// rfq-modal.js
//
// RFQ is a revenue path, not a form. Website RFQs become real Zoho quotes worth five
// figures each, so the rules here are:
//   1. This file must never throw on load. Every top-level lookup is guarded.
//   2. A submission must never fail silently. If it does not land, the customer is told
//      and offered a retry and a phone number.
//   3. Nothing here may discard what the customer typed without saying so.
//
// NOTE ON TRANSPORT: submission still uses JSONP against a Google Apps Script doGet
// endpoint. That is deliberate - we do not know whether the script implements doPost, and
// switching blind would risk killing the channel. What changed is that failure is now
// detected (timeout + onerror) instead of hanging forever. Moving to a POST, or better, to
// a Shopify draft order, is the real fix and needs the endpoint verified first.

var RFQ_ENDPOINT = "https://script.google.com/macros/s/AKfycbx0tyw2AZv7zIAL-jCjiMBztqhtRYvhNC7M4cT-SPxBeW5q-40tY8Q_2FogYlvms0Qi/exec";
var FEEDBACK_ENDPOINT = "https://script.google.com/macros/s/AKfycbzDiXtCNkGzNdnPJ-sCWyqvsgjkZVocsPVsKwXlgeu1-lloJCgVhgriYfLGYp9UzYLD/exec";
var RFQ_TIMEOUT_MS = 20000;
var RFQ_PHONE = "1-844-663-8257";

// Required fields, with the labels shown to the customer when one is missing.
var RFQ_REQUIRED = [
  { id: 'rfq-first-name', label: 'First name' },
  { id: 'rfq-last-name',  label: 'Last name' },
  { id: 'rfq-email',      label: 'Email' },
  { id: 'rfq-phone',      label: 'Phone' },
  { id: 'rfq-zip',        label: 'Zip' }
];

// GUARDED: previously this was an unguarded getElementById(...).addEventListener at the top
// of the file. On any page without the trigger button it threw a TypeError and every
// function below it never registered - no modal, no submission, no error shown.
(function bindRfqTrigger() {
  var trigger = document.getElementById('openRfqModalBtn');
  if (!trigger) return;
  trigger.addEventListener('click', openRfqModal);
})();

function openRfqModal() {
  var modal = document.getElementById('rfq-modal');
  if (!modal) return;
  modal.classList.remove('hidden');
  renderRfqModal('step1');
}

// Define the modal flow.
var rfqModalFlows = {
  step1: {
    header: "Request Your Quote",
    content:
      "<p>Please confirm your information:</p>" +
      "<div style='display: flex; flex-direction: column; gap: 1rem; margin-top: 1rem; margin-bottom: 1rem;'>" +
        "<div style='display: flex; gap: 1rem;'>" +
          "<input type='text' id='rfq-first-name' placeholder='First Name' style='flex:1;' />" +
          "<input type='text' id='rfq-last-name' placeholder='Last Name' style='flex:1;' />" +
        "</div>" +
        "<div style='display: flex; gap: 1rem;'>" +
          "<input type='tel' id='rfq-phone' placeholder='Phone' style='flex:1;' />" +
          "<input type='text' id='rfq-zip' placeholder='Zip' style='flex:1;' />" +
        "</div>" +
        "<div style='display: flex; gap: 1rem;'>" +
          "<input type='email' id='rfq-email' placeholder='Email' style='flex:1; max-width:100%; box-sizing:border-box;' />" +
        "</div>" +
        "<input type='text' id='rfq-company' placeholder='Company' />" +
        "<input type='text' id='rfq-address' placeholder='Address' />" +
        "<div style='display: flex; gap: 1rem;'>" +
          "<input type='text' id='rfq-city' placeholder='City' style='flex:1;' />" +
          "<input type='text' id='rfq-state' placeholder='State' style='flex:1;' />" +
        "</div>" +
      "</div>" +
      "<div id='rfq-form-error' role='alert' style='color:#A32D2D; font-size:0.875rem; margin-bottom:1rem; min-height:1.1rem;'></div>" +
      "<div id='rfq-cart-table'></div>" +
      "<p style='margin-top: 2rem; margin-bottom: 1rem; font-style: italic;'>Note: Quotes are based on your shipping zip code. Please make sure that you have entered it correctly.</p>",
    buttons: [
      // Was labelled "Back", which reads as "previous step" but actually closed the modal
      // and discarded everything typed. There is no step before this one.
      { text: "Cancel", action: "close" },
      { text: "Submit", action: "step2" }
    ]
  },
  step2: {
    header: "Got a Second?",
    image: "url(https://cdn.shopify.com/s/files/1/0600/3300/7699/files/5423350_2808354.svg?v=1742482732)",
    content:
      "<p style='margin-bottom: 2rem;'>We'd love to know how you're enjoying Metals Delivered!</p>" +
      "<label for='feedback-dropdown'>Feedback Type:</label><br/>" +
      "<select id='feedback-dropdown' style='margin-top: .5rem; margin-bottom: 1rem;'>" +
        "<option value=''>Select type</option>" +
        "<option value='general'>General</option>" +
        "<option value='product'>Product</option>" +
        "<option value='service'>Service</option>" +
        "<option value='other'>Other</option>" +
      "</select><br/>" +
      "<label for='feedback-textarea'>Your Feedback:</label><br/>" +
      "<textarea id='feedback-textarea' rows='4' style='margin-top: .5rem; width:100%;'></textarea>",
    buttons: [
      { text: "Skip", action: "step4_logged_in", condition: "loggedIn" },
      { text: "Leave Feedback", action: "step3_logged_in", condition: "loggedIn", id: "leave-feedback-btn" },
      { text: "Skip", action: "step3_guest", condition: "guest" },
      { text: "Send Feedback", action: "step3_guest", condition: "guest", id: "leave-feedback-btn" }
    ]
  },
  // The image: entries below previously pointed at /assets/*.png files that do not exist in
  // this theme, so every one of these screens 404'd its illustration. Removed rather than
  // guessed at. Add real ones with {{ 'name.png' | asset_url }} if wanted.
  step3_logged_in: {
    header: "Thank You!",
    content: "We appreciate your time. We'll be in touch soon!",
    buttons: [ { text: "OK", action: "close" } ]
  },
  step4_logged_in: {
    header: "All Set!",
    content: "Thanks again for your request!",
    buttons: [ { text: "Close", action: "close" } ]
  },
  step3_guest: {
    header: "Create Account",
    content: "Your request has been submitted! Want to create an account?",
    buttons: [
      { text: "Skip", action: "final_step1_guest" },
      { text: "Create Account", link: "/account/register" }
    ]
  },
  final_step1_guest: {
    header: "Thank You!",
    content: "Thanks again! We'll get back to you regarding your quote ASAP!",
    buttons: [ { text: "OK", action: "close" } ]
  },
  final_step2_guest: {
    header: "Nice Job!",
    content: "We've submitted your request! Would you like to explore on-boarding?",
    buttons: [
      { text: "No Thanks", link: "/" },
      { text: "Continue To Onboarding", link: "/collections/all" }
    ]
  }
};

// --- small DOM helpers, all null-safe ---
function rfqSetHeader(text) {
  var el = document.getElementById('rfq-modal-header');
  if (el) el.innerText = text;
}

function rfqSetImage(image) {
  var el = document.getElementById('rfq-modal-image');
  if (!el) return;
  // Previously assigned modalData.image unconditionally, so steps without an image got the
  // literal string "undefined" as a background-image.
  el.style.backgroundImage = image || 'none';
  el.style.display = image ? '' : 'none';
}

function rfqSetText(html) {
  var el = document.getElementById('rfq-modal-text');
  if (el) el.innerHTML = html;
}

function rfqButtonsContainer() {
  return document.getElementById('rfq-modal-buttons');
}

function rfqValue(id) {
  var el = document.getElementById(id);
  return el && el.value ? el.value.trim() : "";
}

// Render the modal content for the current step.
function renderRfqModal(step) {
  var modalData = rfqModalFlows[step];
  if (!modalData) return;

  rfqSetHeader(modalData.header);
  rfqSetImage(modalData.image);
  rfqSetText(modalData.content);

  var buttonsContainer = rfqButtonsContainer();
  if (!buttonsContainer) return;
  buttonsContainer.innerHTML = '';

  var visibleButtons = modalData.buttons.filter(function(button) {
    if (button.condition && button.condition !== (window.customerIsLoggedIn ? 'loggedIn' : 'guest')) {
      return false;
    }
    return true;
  });

  visibleButtons.forEach(function(button, index) {
    var btn = document.createElement('button');
    btn.innerText = button.text;

    if (step === 'step1') {
      btn.className = (index === 0) ? "btn1 btn1-ghost" : "btn1 btn1-primary";
    } else if (visibleButtons.length === 1) {
      btn.className = "btn1 btn1-primary";
    } else {
      btn.className = (index === 0) ? "btn1 btn1-default" : "btn1 btn1-primary";
    }

    if (button.id) btn.id = button.id;

    if (step === 'step1' && button.text.toLowerCase() === 'submit') {
      // Stable id so validation does not depend on nth-child position.
      btn.id = 'rfq-submit-btn';
      btn.addEventListener('click', function(event) {
        event.preventDefault();
        var missing = rfqMissingFields();
        if (missing.length) {
          // Previously the button was made unclickable with pointer-events:none and a
          // generic alert, so the customer had no idea which field was the problem.
          rfqShowFieldError("Please add: " + missing.join(", "));
          return;
        }
        rfqShowFieldError("");
        submitRfq();
      });
    } else if (step === 'step2' && button.id === 'leave-feedback-btn') {
      btn.addEventListener('click', function(event) {
        event.preventDefault();
        submitFeedback(button.action);
      });
    } else {
      btn.addEventListener('click', function() {
        if (button.link) {
          window.location.href = button.link;
        } else {
          handleRfqModalAction(button.action);
        }
      });
    }

    buttonsContainer.appendChild(btn);
  });

  if (step === 'step1') {
    autofillRfqInputs();
    populateCartTable();
    setupStep1Validation();
  }
  if (step === 'step2') {
    setupFeedbackValidation();
  }
}

function handleRfqModalAction(action) {
  if (action === 'close') {
    var modal = document.getElementById('rfq-modal');
    if (modal) modal.classList.add('hidden');
  } else if (typeof action === 'string' && action.indexOf('http') === 0) {
    window.location.href = action;
  } else {
    renderRfqModal(action);
  }
}

function autofillRfqInputs() {
  var sourceFields = {
    company:   document.getElementById('shipto-company'),
    firstName: document.getElementById('shipto-first_name'),
    lastName:  document.getElementById('shipto-last_name'),
    email:     { value: window.customerEmail },
    phone:     document.getElementById('shipto-phone'),
    address:   document.getElementById('shipto-address1'),
    city:      document.getElementById('shipto-city'),
    state:     document.getElementById('shipto-province'),
    zip:       document.getElementById('shipto-zip')
  };

  var modalFields = {
    company:   document.getElementById('rfq-company'),
    firstName: document.getElementById('rfq-first-name'),
    lastName:  document.getElementById('rfq-last-name'),
    email:     document.getElementById('rfq-email'),
    phone:     document.getElementById('rfq-phone'),
    address:   document.getElementById('rfq-address'),
    city:      document.getElementById('rfq-city'),
    state:     document.getElementById('rfq-state'),
    zip:       document.getElementById('rfq-zip')
  };

  Object.keys(sourceFields).forEach(function(key) {
    if (sourceFields[key] && modalFields[key]) {
      modalFields[key].value = sourceFields[key].value || '';
    }
  });
}

function populateCartTable() {
  fetch('/cart.js')
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      var tableContainer = document.getElementById('rfq-cart-table');
      if (!tableContainer) return;

      var items = (cart && cart.items) ? cart.items : [];
      if (items.length === 0) {
        tableContainer.innerHTML = "<p>Your cart is empty.</p>";
        return;
      }

      var tableHtml = "<table style=\"width:100%; border-collapse: collapse; margin-top: 1rem;\">" +
        "<thead><tr>" +
          "<th style=\"text-align: left; border: 1px solid #ddd; padding: 8px;\">Product</th>" +
          "<th style=\"text-align: left; border: 1px solid #ddd; padding: 8px;\">Qty</th>" +
          "<th style=\"text-align: left; border: 1px solid #ddd; padding: 8px;\">Price</th>" +
        "</tr></thead><tbody>";

      items.forEach(function(item) {
        tableHtml += "<tr>" +
          "<td style=\"border: 1px solid #ddd; padding: 8px;\">" + item.product_title + "</td>" +
          "<td style=\"border: 1px solid #ddd; padding: 8px;\">" + item.quantity + "</td>" +
          "<td style=\"border: 1px solid #ddd; padding: 8px;\">" + formatMoney(item.line_price) + "</td>" +
        "</tr>";
      });

      tableHtml += "</tbody></table>";
      tableContainer.innerHTML = tableHtml;
    })
    .catch(function(error) {
      console.error('[RFQ] Error fetching cart for table:', error);
      var tableContainer = document.getElementById('rfq-cart-table');
      if (tableContainer) tableContainer.innerHTML = "<p>We could not load your cart just now. You can still send this request.</p>";
    });
}

// --- validation ---
function rfqMissingFields() {
  return RFQ_REQUIRED
    .filter(function(f) { return rfqValue(f.id) === ""; })
    .map(function(f) { return f.label; });
}

function rfqShowFieldError(message) {
  var el = document.getElementById('rfq-form-error');
  if (el) el.textContent = message || "";
}

function setupStep1Validation() {
  setTimeout(function() {
    var btn = document.getElementById('rfq-submit-btn');
    if (!btn) return;

    function refresh() {
      var missing = rfqMissingFields();
      // Dim to signal incompleteness, but keep the button clickable so the customer can
      // find out WHY it is not ready.
      btn.style.opacity = missing.length ? '0.6' : '1';
      if (!missing.length) rfqShowFieldError("");
    }

    RFQ_REQUIRED.forEach(function(f) {
      var el = document.getElementById(f.id);
      if (el) el.addEventListener('input', refresh);
    });

    refresh();
  }, 100);
}

// --- submission ---
function rfqShowSending() {
  rfqSetHeader("Sending your request");
  rfqSetImage(null);
  rfqSetText("<p>One moment - we are sending your request to our team.</p>");
  var container = rfqButtonsContainer();
  if (container) container.innerHTML = '';
}

// The whole point of this function: the customer finds out. Previously a failed JSONP call
// left the modal frozen on step 1 with no message, and the lead existed nowhere.
function rfqShowFailure(formData, cartData) {
  rfqSetHeader("We could not send that");
  rfqSetImage(null);
  rfqSetText(
    "<p>Your request did not reach us. That is on our end, not anything you did.</p>" +
    "<p>Please try again. If it still will not go through, call us and we will take the details straight from you:</p>" +
    "<p style='font-size:1.15rem;'><strong>" + RFQ_PHONE + "</strong></p>"
  );

  var container = rfqButtonsContainer();
  if (!container) return;
  container.innerHTML = '';

  var closeBtn = document.createElement('button');
  closeBtn.className = 'btn1 btn1-ghost';
  closeBtn.innerText = 'Close';
  closeBtn.addEventListener('click', function() { handleRfqModalAction('close'); });

  var retryBtn = document.createElement('button');
  retryBtn.className = 'btn1 btn1-primary';
  retryBtn.innerText = 'Try again';
  retryBtn.addEventListener('click', function() {
    rfqShowSending();
    sendRfqJsonp(formData, cartData);
  });

  container.appendChild(closeBtn);
  container.appendChild(retryBtn);
}

function submitRfq() {
  var formData = {
    company:   rfqValue('rfq-company'),
    firstName: rfqValue('rfq-first-name'),
    lastName:  rfqValue('rfq-last-name'),
    email:     rfqValue('rfq-email'),
    phone:     rfqValue('rfq-phone'),
    address:   rfqValue('rfq-address'),
    city:      rfqValue('rfq-city'),
    state:     rfqValue('rfq-state'),
    zip:       rfqValue('rfq-zip')
  };

  rfqShowSending();

  fetch('/cart.js')
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      var items = (cart && cart.items) ? cart.items : [];
      var cartData = items.map(function(item) {
        return {
          productTitle: item.product_title,
          variantTitle: item.variant_title,
          sku:          item.sku,
          variantId:    item.variant_id,
          quantity:     item.quantity,
          priceEach:    formatMoney(item.price),
          totalPrice:   formatMoney(item.line_price)
        };
      });
      sendRfqJsonp(formData, cartData);
    })
    .catch(function(error) {
      // A cart read failure used to abort the whole submission and lose the lead. Send the
      // contact details anyway - a named prospect with no line items still beats nothing.
      console.error('[RFQ] Could not read cart, sending contact details only:', error);
      sendRfqJsonp(formData, []);
    });
}

function sendRfqJsonp(formData, cartData) {
  var callbackName = "rfqCallback_" + Date.now();
  var settled = false;
  var scriptEl = null;
  var timer = null;

  function cleanup() {
    if (timer) clearTimeout(timer);
    if (scriptEl && scriptEl.parentNode) scriptEl.parentNode.removeChild(scriptEl);
    try { delete window[callbackName]; } catch (e) { window[callbackName] = undefined; }
  }

  function fail(reason) {
    if (settled) return;
    settled = true;
    console.error('[RFQ] Submission failed:', reason, formData);
    cleanup();
    rfqShowFailure(formData, cartData);
  }

  window[callbackName] = function(response) {
    if (settled) return;
    settled = true;
    console.log('[RFQ] Submission acknowledged:', response);
    cleanup();
    handleRfqModalAction('step2');
  };

  var params = new URLSearchParams({
    callback:  callbackName,
    type:      'rfq',
    company:   formData.company,
    firstName: formData.firstName,
    lastName:  formData.lastName,
    email:     formData.email,
    phone:     formData.phone,
    address:   formData.address,
    city:      formData.city,
    state:     formData.state,
    zip:       formData.zip,
    cartData:  JSON.stringify(cartData)
  });

  scriptEl = document.createElement('script');
  scriptEl.src = RFQ_ENDPOINT + "?" + params.toString();
  scriptEl.onerror = function() { fail('script load error'); };

  timer = setTimeout(function() { fail('timeout after ' + RFQ_TIMEOUT_MS + 'ms'); }, RFQ_TIMEOUT_MS);

  document.body.appendChild(scriptEl);
}

// --- feedback (optional, so failure just moves the customer along) ---
function submitFeedback(actionAfter) {
  var feedbackDropdown = document.getElementById('feedback-dropdown');
  var feedbackTextarea = document.getElementById('feedback-textarea');

  var feedbackData = {
    feedbackType: feedbackDropdown ? feedbackDropdown.value : '',
    feedbackText: feedbackTextarea ? feedbackTextarea.value.trim() : ''
  };

  var callbackName = "feedbackCb_" + Date.now();
  var settled = false;
  var scriptEl = null;
  var timer = null;

  function cleanup() {
    if (timer) clearTimeout(timer);
    if (scriptEl && scriptEl.parentNode) scriptEl.parentNode.removeChild(scriptEl);
    try { delete window[callbackName]; } catch (e) { window[callbackName] = undefined; }
  }

  function settle(logLabel, detail) {
    if (settled) return;
    settled = true;
    console.log('[RFQ feedback] ' + logLabel, detail);
    cleanup();
    // Feedback is a nice-to-have. Never trap the customer here, even on failure.
    handleRfqModalAction(actionAfter);
  }

  window[callbackName] = function(response) { settle('acknowledged:', response); };

  var params = new URLSearchParams({
    callback:     callbackName,
    type:         'feedback',
    feedbackType: feedbackData.feedbackType,
    feedbackText: feedbackData.feedbackText
  });

  scriptEl = document.createElement('script');
  scriptEl.src = FEEDBACK_ENDPOINT + "?" + params.toString();
  scriptEl.onerror = function() { settle('send failed, continuing anyway', feedbackData); };

  timer = setTimeout(function() { settle('timed out, continuing anyway', feedbackData); }, RFQ_TIMEOUT_MS);

  document.body.appendChild(scriptEl);
}

function setupFeedbackValidation() {
  var dropdown = document.getElementById('feedback-dropdown');
  var textarea = document.getElementById('feedback-textarea');
  var feedbackBtn = document.getElementById('leave-feedback-btn');

  // Previously these addEventListener calls were unguarded and threw if the elements were
  // absent.
  if (!dropdown || !textarea) return;

  if (feedbackBtn) feedbackBtn.disabled = true;

  function checkValidation() {
    if (!feedbackBtn) return;
    feedbackBtn.disabled = !(dropdown.value !== "" && textarea.value.trim() !== "");
  }

  dropdown.addEventListener('change', checkValidation);
  textarea.addEventListener('input', checkValidation);
}

// Utility to format cents to dollars. Defined once - there were three identical copies.
function formatMoney(cents) {
  var n = Number(cents);
  if (!isFinite(n)) return '$0.00';
  return '$' + (n / 100).toFixed(2);
}
